export function userContextReducer(state = null, action) {
    switch (action.type) {
        case 'SET_USERCONTEXT':
            return {
							...state,
							isInternalTenant: action.isInternalTenant,
                            loginHint: action.loginHint
              			}; 
        default:
            return state;
    }
}